import React from 'react'
import styled from 'styled-components'

import { FaPlay } from 'react-icons/fa'
import { AnimatePresence, motion } from "framer-motion"

const Icon = styled.div`
    padding: 0.5rem;
    border-radius: 5px;
    font-size: 0.7rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--primary-color);
    :hover {
        filter: brightness(var(--brightness));
    };
`

const ToggleButton = props => {
    const {
        open,
        onSelect
    } = props

    return (
        <div style={{alignSelf: 'start'}}>
            <AnimatePresence initial={false}>
                <motion.div key='content' size='100%' position="relative" background='transparent'
                    positionTransition
                    animate={{ rotate: open ? 90 : 0}}
                    transition={{ duration: 0.2 }}>
                        <Icon open={open} onClick={onSelect}><FaPlay/></Icon>
                </motion.div>
            </AnimatePresence>
        </div>
    )
}

export default ToggleButton